module.exports = "/images/iq.svg?bb08227bbd66f8d6b34f91da9efd4c5c";